import { render, staticRenderFns } from "./annotation.vue?vue&type=template&id=3d190ce1&scoped=true&"
import script from "./annotation.vue?vue&type=script&lang=js&"
export * from "./annotation.vue?vue&type=script&lang=js&"
import style0 from "./annotation.vue?vue&type=style&index=0&id=3d190ce1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d190ce1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d190ce1')) {
      api.createRecord('3d190ce1', component.options)
    } else {
      api.reload('3d190ce1', component.options)
    }
    module.hot.accept("./annotation.vue?vue&type=template&id=3d190ce1&scoped=true&", function () {
      api.rerender('3d190ce1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UploadFile/annotation.vue"
export default component.exports